import { Link } from './content'

const Footer = {
  payoff: 'Tutta un\'altra energia <br>per le tue vendite.',
  company: 'Company @ info',
  iva: 'pIVA',
  contacts: {
    title: 'Contact Info',
    email: 'info@t-data.it',
    phone: '0331 1090043',
    address: 'Via Filippo Turati, 111 <br>20023 Cerro Maggiore (MI)',
  },
  upper: [
    {
      type: 'Text',
      header: { ...Link },
      className: 'Contacts',
      collapsable: false,
      main: [
        { content: 'info@data.it' },
        { content: 'Indirizzo 1' },
        { content: 'Indirizzo 2' },
      ]
    },
    {
      type: 'MenuItem',
      header: { ...Link },
      main: null
    },
    {
      type: 'MenuItem',
      header: { ...Link },
      main: [
        Link,
        Link,
        Link,
        Link,
        Link,
      ]
    },
    {
      type: 'MenuItem',
      header: { ...Link },
      main: [
        Link,
        Link,
        Link,
        Link,
        Link,
      ]
    },
    {
      type: 'MenuItem',
      header: { ...Link },
      main: null
    },
    {
      type: 'MenuItem',
      header: { ...Link },
      main: [
        Link,
        Link,
        Link,
        Link,
        Link,
      ]
    },
  ],
  lower: [
    {
      className: 'LowerMenu',
      type: 'MenuItem',
      collapsable: false,
      direction: 'row',
      main: [
        Link,
        Link,
        Link,
      ]
    },
    {
      className: 'LowerMenu',
      type: 'MenuItem',
      direction: 'row',
      collapsable: false,
      main: [
        Link,
        Link,
        Link,
      ]
    }
  ]
}

export const FooterIcons = [
  {
    attributes: {
      name: 'stradale',
      alternativeText: 'Stradale',
      width: 72,
      height: 72,
      url: '/assets/images/stradale.svg'
    }
  },
  {
    attributes: {
      name: 'marittimo',
      alternativeText: 'Marittimo',
      width: 72,
      height: 72,
      url: '/assets/images/marittimo.svg'
    }
  },
  {
    attributes: {
      name: 'intermodale',
      alternativeText: 'Intermodale',
      width: 72,
      height: 72,
      url: '/assets/images/intermodale.svg'
    }
  },
  {
    attributes: {
      name: 'aereo',
      alternativeText: 'Aereo',
      width: 72,
      height: 72,
      url: '/assets/images/aereo.svg'
    }
  },
  {
    attributes: {
      name: 'logistica',
      alternativeText: 'Logistica',
      width: 72,
      height: 72,
      url: '/assets/images/logistica.svg'
    }
  }
]

export default Footer
